import { render, staticRenderFns } from "./Banktemporary.vue?vue&type=template&id=2f24570e"
import script from "./Banktemporary.vue?vue&type=script&lang=js"
export * from "./Banktemporary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports